import { Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { MPointsPage } from '../features/mpoints';
import useAppStore from '../store/rootStore.ts';
import { createPageBackgroundSx } from '../styles/pageBackground.ts';

export const Route = createFileRoute('/mpoints')({
  component: MPointsRouteComponent,
  beforeLoad: () => {
    if (!useAppStore.getState().config?.features.rewardsEnabled) {
      throw redirect({ to: '/trade', replace: true });
    }
  },
});

const mpointsPageSx = createPageBackgroundSx();

function MPointsRouteComponent() {
  return (
    <Stack sx={mpointsPageSx}>
      <MPointsPage />
    </Stack>
  );
}
